let isSigninRequired: boolean | undefined = undefined;

export function getIsSigninRequired(): boolean {
    return !!isSigninRequired;
}

export function setIsSigninRequired(isSigninNeeded: boolean): void {
    isSigninRequired = isSigninNeeded;
}
